// Thư mục: src/stores/dmChecklistItemStore.js
import { defineStore } from "pinia";
import { DmChecklistItemApi } from "@/services/dmXeChecklistService";

export const useDmChecklistItemStore = defineStore("dmChecklistItem", {
  state: () => ({
    // State cho danh sách phân trang
    isLoading: false,
    error: null,
    items: [], // Danh sách hiển thị trên table

    // State phân trang
    page: 0,
    size: 10,
    sort: "id,desc",
    totalPages: 1,
    totalElements: 0,

    // State MỚI: cho danh sách đầy đủ (để gán vào Loại Xe)
    allActiveItems: [],
    isLoadingAll: false,
  }),

  getters: {
    currentPage(state) {
      return state.page + 1;
    },
  },

  actions: {
    setPage(p1) {
      const p0 = Math.max(0, p1 - 1);
      if (p0 !== this.page) this.page = p0;
    },
    setSize(s) {
      this.size = s;
      this.page = 0;
    },

    // Action cho danh sách phân trang
    async fetchList() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await DmChecklistItemApi.list({
          page: this.page,
          size: this.size,
          sort: this.sort,
        });
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
        this.size = data.size ?? this.size;
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh sách hạng mục";
      } finally {
        this.isLoading = false;
      }
    },

    // Action CRUD
    async createChecklist(form) {
      await DmChecklistItemApi.create(form);
      await this.fetchList();
    },
    async updateChecklist(id, form) {
      await DmChecklistItemApi.update(id, form);
      await this.fetchList();
    },
    async deleteChecklist(id) {
      await DmChecklistItemApi.remove(id);
      if (this.items.length === 1 && this.page > 0) this.page -= 1;
      await this.fetchList();
    },

    // Action MỚI: Lấy tất cả
    async fetchAllActive() {
      this.isLoadingAll = true;
      try {
        const data = await DmChecklistItemApi.listAllActive();
        // Sắp xếp theo thứ tự ưu tiên (viTri) ngay tại store
        this.allActiveItems = (data || []).sort(
          (a, b) => (a.viTri || 999) - (b.viTri || 999)
        );
      } catch (e) {
        // Báo lỗi cho modal (nếu cần)
        console.error("Lỗi tải danh sách hạng mục active:", e);
      } finally {
        this.isLoadingAll = false;
      }
    },
  },
});
